import { defineAsyncComponent } from 'vue'

export default {
  install: (app, options) => {
    app.component('ExpandItemComponent', defineAsyncComponent(() => import('./ExpandItemComponent.vue')))
  }
}
